module.exports = __webpack_public_path__ + "img/gaoxin-logo.31b79a25.png";